import { render, staticRenderFns } from "./VideoCollection.vue?vue&type=template&id=e2741b12&scoped=true&"
import script from "./VideoCollection.vue?vue&type=script&lang=js&"
export * from "./VideoCollection.vue?vue&type=script&lang=js&"
import style0 from "./VideoCollection.vue?vue&type=style&index=0&id=e2741b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2741b12",
  null
  
)

export default component.exports